import { CommonAPI } from "../CommonAPI/CommonAPI";
import Cookies from "js-cookie";

export const SendAlbum = async (Mode, Id, CustomerId) => {

  let response;
  try {
    const queryParams = new URLSearchParams(window.location.search);

    const device_token_url = queryParams.get("device_token");
    const token_url = queryParams.get("token");
    const SV_url = queryParams.get("SV");

    const cookie_device_token = Cookies.get("device_token");
    const cookie_token = Cookies.get("token");
    const cookie_SV = Cookies.get("SV");

    const DeviceToken = sessionStorage.getItem("device_token") ?? "";
    const token = sessionStorage.getItem("token") ?? "";
    const SV = sessionStorage.getItem("SV") ?? "";

    const finalDeviceToken =
      window.location.hostname === "localhost" ||
      window.location.hostname === "zen"
        ? "UWXWE08KEDC46Q44"
        : DeviceToken || cookie_device_token || device_token_url || "";
    const finalToken =
      window.location.hostname === "localhost" ||
      window.location.hostname === "zen"
        ? "JYILHHIV03E21GP77V73"
        : token || token_url || cookie_token || "";
    const finalSv =
      window.location.hostname === "localhost" ||
      window.location.hostname === "zen"
        ? "0"
        : SV || SV_url || cookie_SV || "";

    // alert(`cookie_device_token ${cookie_device_token}`);
    // alert(`finalDeviceToken ${finalDeviceToken}`);

    // const token = sessionStorage.getItem("token") ?? "LGN103D12R6A17HG4CAI" ?? "";
    // const DeviceToken = "U015UW9PV4JY9S9A" ?? "";

    // (window.location.hostname === 'localhost'
    //   || window.location.hostname === 'zen'
    //   || window.location.hostname === 'fgstore.web') ?


    const combinedValue = JSON.stringify({
      Token: `${finalToken}` ?? "",
      DeviceToken: finalDeviceToken ?? "",
      Mode: `${Mode}` ?? "",
      AlbumMasterid: `${Id}` ?? "",
      CustomerId: `${CustomerId}` ?? "",
    });

    const body = {
      Token: `${finalToken}`,
      DeviceToken: finalDeviceToken,
      SV: finalSv,
      ReqData: combinedValue,
    };

    response = await CommonAPI(body);
  } catch (error) {
    console.error("Error:", error);
  }
  return response;
};
